import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { List, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useUserState } from '@context/UserContext';
import NavItem from './NavItem';
import trackHotjarEvent from '@components/Analytics/trackHotjarEvent';
import { useFeature } from 'flagged';
const useStyles = makeStyles()((theme, { additionalWidth }) => {
    const contentMaxWidth = `${1139 + additionalWidth}px`;
    const marketingMaxWidth = `${1079 + additionalWidth}px`;
    return {
        container: {
            fontFamily: theme.typography.fontFamily,
            padding: theme.spacing(1),
            border: `1px solid ${theme.palette.grey[100]}`,
        },
        link: {
            width: '180px',
            color: theme.palette.grey[600],
            padding: theme.spacing(1, 1.5),
            borderRadius: '4px',
            '& span': {
                fontSize: '12px',
                fontWeight: 600,
            },
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.main,
            },
        },
        divider: {
            margin: theme.spacing(1, 0),
        },
        myTournaments: {
            display: 'none',
            '@media (max-width: 1469px)': {
                display: 'flex',
            },
        },
        rewards: {
            display: 'none',
            '@media (max-width: 1339px)': {
                display: 'flex',
            },
        },
        content: {
            display: 'none',
            [`@media (max-width: ${contentMaxWidth})`]: {
                display: 'flex',
            },
        },
        marketplace: {
            display: 'none',
            [`@media (max-width: ${marketingMaxWidth})`]: {
                display: 'flex',
            },
        },
    };
});
/**
 * A drop down menu that is displayed when the "..." button is clicked Generally used as utility to allow users to quickly navigate their support options
 */
export const OtherMenu = () => {
    const { authenticated, userProfile } = useUserState();
    const additionalWidth = authenticated ? 100 : 0;
    const { classes, cx } = useStyles({ additionalWidth });
    const isMobilePromotionEnabled = !!useFeature('enable_mobile_app_promotion');
    const isCoinBonusesDisabled = !!useFeature('disable_coin_bonuses');
    const isWithdrawalOnlyEnabled = !!useFeature('semisonic_phase_2');
    const handleSupportClick = () => {
        var _a;
        if (window.zE) {
            const widget = ((_a = window.zE) === null || _a === void 0 ? void 0 : _a.widget) === 'messenger' ? 'messenger' : 'webWidget';
            window.zE(widget, 'show');
            window.zE(widget, 'open');
            trackHotjarEvent(`Click support`);
        }
    };
    return (_jsxs(List, { component: "nav", classes: { root: classes.container }, children: [authenticated && userProfile && !isWithdrawalOnlyEnabled && (_jsx(NavItem, { className: cx(classes.link, classes.myTournaments), to: `/user/profile/${encodeURI(userProfile.handle)}/tournaments`, linkText: "My Tournaments" })), authenticated && !isCoinBonusesDisabled && !isWithdrawalOnlyEnabled && (_jsx(NavItem, { className: cx(classes.link, classes.rewards), href: "/coins", linkText: "Rewards" })), !isWithdrawalOnlyEnabled && (_jsxs(_Fragment, { children: [_jsx(NavItem, { href: "/marketplace", linkText: "Marketplace", className: cx(classes.link, isMobilePromotionEnabled ? classes.marketplace : '') }), _jsx(NavItem, { href: "/content", linkText: "News", className: cx(classes.link, isMobilePromotionEnabled ? classes.content : '') }), _jsx(NavItem, { to: "/brands", linkText: "Brands", className: classes.link }), _jsx(Divider, { className: classes.divider })] })), _jsx(NavItem, { to: "/about/terms-and-conditions", linkText: "Terms of Service", className: classes.link }), _jsx(NavItem, { to: "/about/privacy-policy", linkText: "Privacy Policy", className: classes.link }), _jsx(NavItem, { button: true, onClick: handleSupportClick, linkText: "Help", className: classes.link }), _jsx(NavItem, { href: "https://support.repeat.gg/hc/en-us", target: "_blank", linkText: "Knowledge Base", className: classes.link })] }));
};
export default OtherMenu;
